module.exports = __webpack_public_path__ + "static/img/brand-first-bg-right.4c839fbe.png";